<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/leaveoffice/leaveoffice',title:'离职交接'},{title:'离职申请'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="formInline" class="demo-ruleForm h-formbLine h-formbLine1">
                        <el-form-item label="被交接人" class="h-elformWrap-1">
                            <el-input readonly
                                      style="width: 3rem"
                                      v-model="formInline.leaveName"
                                      :title="formInline.leaveName">
                            </el-input>
                            <el-button type="primary" @click="handleLeaveClick" icon="el-icon-plus" style="margin-left: 0.2rem" v-auth="'chooseLeave'">
                                选择
                            </el-button>
                        </el-form-item>
                        <el-form-item label="交接说明" class="h-elformWrap-1 yh-inputborder">
                            <el-input type="textarea"
                                      :rows="5"
                                      placeholder="请输入离职原因......"
                                      v-model="formInline.leaveExplain"
                                      :title="formInline.leaveExplain">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="承接人" class="h-elformWrap-1">
                            <el-input readonly
                                      style="width: 3rem"
                                      placeholder="请选择"
                                      v-model="formInline.handoverName"
                                      :title="formInline.handoverName">
                            </el-input>
                            <el-button type="primary" @click="handleIconClick"  icon="el-icon-plus" style="margin-left: 0.2rem">
                                选择
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="h-txtCenter h-mrt60">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="renovate">返回</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveApply">提交申请</el-button>
                </div>
            </div>
            <alluser :visible.sync="visible" @choseUser="choseUser" title="选择用户"/>
            <alluser :visible.sync="visible2" @choseUser="choseUser2" title="选择用户"/>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import alluser from '../../components/dialog/alluser'
    export default {
        components: {alluser},
        data() {
            return {
                formInline: {
                    leaveCode: '',
                    leaveName: '',
                    leaveExplain: '',
                    handoverCode: '',
                    handoverName: ''
                },
                //table列表
                tableData: [],
                instid: '',
                showhistory:false,
                visible: false,
                visible2: false,
            }
        },
        created() {
            this.query();
        },
        methods: {
            query(){
                this.formInline.leaveCode = this._user.usercode;
                this.formInline.leaveName = this._user.username;
            },
            saveApply() {
                if (this.formInline.leaveExplain == '') {
                    this.$msg.msge("请输入离职说明！");
                    return false;
                }
                if (this.formInline.handoverCode == '' || this.formInline.handoverName == '') {
                    this.$msg.msge("请选择交接人！");
                    return false;
                }
                ss.leaveService.insert(this.formInline).then(rd=>{
                    if (rd.f == true) {
                        this.$msg.msgs(rd.msg);
                        this.$router.push({
                            path: "/leaveoffice/leaveoffice"
                        });
                    } else {
                        this.$msg.msge(rd.msg);
                    }
                })
            },
            renovate() {
                this.$router.push({
                    path: "/leaveoffice/leaveoffice"
                });
            },
            handleIconClick(){
                this.visible = true;
            },
            handleLeaveClick(){
                this.visible2 = true;
            },
            choseUser(users){
                if(users.length > 1){
                    this.$msg.msge("您只能选择一个人！");
                } else if (users.length <= 0) {
                    this.$msg.msge("请至少选择一条数据！");
                } else if (users.length == 1) {
                    if (this.formInline.leaveCode == users[0].usercode) {
                        this.$msg.msge("您不能选择自己！");
                        return false;
                    }
                    this.formInline.handoverCode = users[0].usercode;
                    this.formInline.handoverName = users[0].username;
                    this.visible = false;
                }
            },
            choseUser2(users){
                if(users.length > 1){
                    this.$msg.msge("您只能选择一个人！");
                } else if (users.length <= 0) {
                    this.$msg.msge("请至少选择一条数据！");
                } else if (users.length == 1) {
                    this.formInline.leaveCode = users[0].usercode;
                    this.formInline.leaveName = users[0].username;
                    this.visible2 = false;
                }
            },
        }
    }
</script>
<style>
    .yh-inputborder .el-textarea__inner{
        border: 1px solid #dedede;
    }
</style>
